import type { DeepPartial } from '@luna/utils-ts';
import type { CurrentAccountConfig } from '@shared/products-feature-configs';

import { roundingSavings } from '../round-up-savings-config/AT';
import { settingsDetails } from '../settings-details-config/AT';
import { statements } from '../statements-config/AT';

export const currentAccount: DeepPartial<CurrentAccountConfig> = {
    sCreditline: true,
    sCreditlineOverdraft: true,
    statements,
    roundingSavings,
    settingsDetails,
    layout: {
        productInfo: {
            showBalanceAndDisposableAmounts: true,
        },
    },
    instantPaymentLimit: {
        showOrderMessage: true,
    },
};
